<template>
  <div>
    <vx-card title="Credit Note">
      <div class="flex flex-col gap-3">
        <div class="flex flex-row gap-3">
          <div class="flex flex-col w-1/2 gap-4">
            <operating-unit-filter :hideShowButton="true" :full="true" />
            <div class="flex flex-col w-full gap-2">
              <span>Debit Note Code</span>
              <multiselect
                v-model="selectedDebitNoteCodes"
                :options="debitNoteCodeOption"
                :multiple="true"
                placeholder="Type to search"
                ref="dn"
                track-by="id"
                @search-change="onDebitNoteSearch"
                label="code"
                class="w-full h-full"
                :max-height="130"
              >
              </multiselect>
            </div>
            <div class="flex flex-col w-full gap-2">
              <span>Type</span>
              <multiselect
                v-model="typeCN"
                :options="typeCnOption"
                placeholder="Type to search"
                ref="typeCn"
                class="w-full h-full"
                :max-height="130"
              >
              </multiselect>
            </div>
          </div>

          <div class="flex flex-col w-1/2 gap-4">
            <div class="w-full">
              <customer-filter
                :multiple="true"
                :full="true"
                :triggerReloadWithTerriotry="true"
              />
            </div>
            <div class="flex flex-col w-full gap-2">
              <span>Credit Note Code</span>
              <multiselect
                v-model="selectedCreditNoteCodes"
                :options="creditNoteOption"
                :multiple="true"
                placeholder="Type to search"
                ref="cn"
                track-by="id"
                @search-change="onCreditNoteSearch"
                label="code"
                class="w-full h-full"
                :max-height="130"
              >
              </multiselect>
            </div>
            <div class="flex flex-col w-full gap-2">
              <span>SOA Number</span>
              <multiselect
                v-model="selectedSOA"
                :options="soaOption"
                :multiple="true"
                placeholder="Type to search"
                ref="cn"
                track-by="id"
                @search-change="onSOASearch"
                label="soa_number"
                class="w-full h-full"
                :max-height="130"
              >
              </multiselect>
            </div>
          </div>
        </div>
        <div class="w-full justify-end flex">
          <vs-button @click="onShow">Show</vs-button>
        </div>
      </div>

      <div class="flex flex-col gap-6">
        <vs-tabs :color="colorx" v-model="tabs">
          <!-- <vs-tab @click="colorx = 'danger'" label="Customer Return Complete">
          <div class="con-tab-ejemplo">
            <complete :isReload="isReload" />
          </div>
        </vs-tab> -->
          <vs-tab @click="colorx = 'warning'" label="Draft">
            <div class="con-tab-ejemplo">
              <draft
                :typeCN="typeCN"
                :isReload="isReload"
                :creditNoteCodes="creditNoteCodes"
                :debitNoteCodes="debitNoteCodes"
                :soaNumbers="soaNumbers"
              />
            </div>
          </vs-tab>
          <!-- <vs-tab @click="colorx = 'warning'" label="Waiting Approval">
          <div class="con-tab-ejemplo">
            <waiting :isReload="isReload" />
          </div>
        </vs-tab>
        <vs-tab @click="colorx = 'warning'" label="Approved">
          <div class="con-tab-ejemplo">
            <approved :isReload="isReload" />
          </div>
        </vs-tab>
        <vs-tab @click="colorx = 'warning'" label="Rejected">
          <div class="con-tab-ejemplo">
            <rejected :isReload="isReload" />
          </div>
        </vs-tab> -->
          <vs-tab @click="colorx = 'warning'" label="Released">
            <div class="con-tab-ejemplo">
              <released
                :typeCN="typeCN"
                :isReload="isReload"
                :creditNoteCodes="creditNoteCodes"
                :debitNoteCodes="debitNoteCodes"
                :soaNumbers="soaNumbers"
              />
            </div>
          </vs-tab>
          <vs-tab @click="colorx = 'warning'" label="Applied">
            <div class="con-tab-ejemplo">
              <applied
                :typeCN="typeCN"
                :isReload="isReload"
                :creditNoteCodes="creditNoteCodes"
                :debitNoteCodes="debitNoteCodes"
                :soaNumbers="soaNumbers"
              />
            </div>
          </vs-tab>
          <vs-tab @click="colorx = 'warning'" label="Waiting Reversal">
            <div class="con-tab-ejemplo">
              <waitingRevers
                :typeCN="typeCN"
                :isReload="isReload"
                :creditNoteCodes="creditNoteCodes"
                :debitNoteCodes="debitNoteCodes"
                :soaNumbers="soaNumbers"
              />
            </div>
          </vs-tab>
          <vs-tab @click="colorx = 'warning'" label="Reversed">
            <div class="con-tab-ejemplo">
              <reversed
                :typeCN="typeCN"
                :isReload="isReload"
                :creditNoteCodes="creditNoteCodes"
                :debitNoteCodes="debitNoteCodes"
                :soaNumbers="soaNumbers"
              />
            </div>
          </vs-tab>
        </vs-tabs>
      </div>
    </vx-card>
  </div>
</template>
<script>
import complete from "./complete.vue";
import draft from "./draft.vue";
import waiting from "./waiting_approval.vue";
import approved from "./approved.vue";
import rejected from "./rejected.vue";
import released from "./released.vue";
import applied from "./applied.vue";
import reversed from "./reversed.vue";
import waitingRevers from "./waiting-reversal.vue";
import operatingUnitFilter from "../../../../components/operatingUnitFilter/operatingUnitFilter.vue";
import debounce from "debounce";
import customerFilter from "../../../../components/customerFilter/customerFilter.vue";

export default {
  components: {
    complete,
    draft,
    rejected,
    approved,
    waiting,
    released,
    applied,
    reversed,
    waitingRevers,
    "operating-unit-filter": operatingUnitFilter,
    "customer-filter": customerFilter,
  },

  async mounted() {
    await this.getCreditNoteCodes("");
    await this.getDebitNotesCode("");
    await this.getDebitNoteSOA("");
    this.showData = true;
  },

  computed: {
    creditNoteCodes() {
      return this.selectedCreditNoteCodes.map((item) => item.code);
    },
    debitNoteCodes() {
      return this.selectedDebitNoteCodes.map((item) => item.code);
    },
    soaNumbers() {
      return this.selectedSOA.map((item) => item.soa_number);
    },
  },
  watch: {},
  data: () => ({
    colorx: "danger",
    tabs: 0,
    isReload: false,
    debounceFunction: null,
    selectedCreditNoteCodes: [],
    creditNoteOption: [],
    debitNoteCodeOption: [],
    soaOption: [],
    showData: false,
    selectedSOA: [],
    selectedDebitNoteCodes: [],
    typeCN:"",
    typeCnOption:["return","claim"],
  }),

  methods: {
    onShow() {
      this.isReload = true;
      this.$nextTick(() => {
        this.isReload = false;
      });
    },
    onCreditNoteSearch(search) {
      if (this.debounceFunction) {
        this.debounceFunction.clear();
      }

      search = search.trim();

      this.debounceFunction = debounce(() => {
        this.getCreditNoteCodes(search);
      }, 500);

      this.debounceFunction();
    },
    onDebitNoteSearch(search) {
      if (this.debounceFunction) {
        this.debounceFunction.clear();
      }

      search = search.trim();

      this.debounceFunction = debounce(() => {
        this.getDebitNotesCode(search);
      }, 500);

      this.debounceFunction();
    },
    onSOASearch(search) {
      if (this.debounceFunction) {
        this.debounceFunction.clear();
      }

      search = search.trim();

      this.debounceFunction = debounce(() => {
        this.getDebitNoteSOA(search);
      }, 500);

      this.debounceFunction();
    },

    async getCreditNoteCodes(search) {
      this.$vs.loading();
      try {
        const response = await this.$http.get("api/v1/credit-note/filter", {
          params: {
            search: search,
            territory_ids:
              this.$store.getters["operatingUnit/getSelectedTerritoryId"],
          },
        });
        this.creditNoteOption = response.data;
        this.$vs.loading.close();
      } catch (err) {
        this.$vs.loading.close();
        console.log(err);
      }
    },

    async getDebitNotesCode(search) {
      this.$vs.loading();
      try {
        const response = await this.$http.get("api/v1/debit-note/cn-filter", {
          params: {
            search: search,
            territory_ids:
              this.$store.getters["operatingUnit/getSelectedTerritoryId"],
          },
        });
        this.debitNoteCodeOption = response.data;
        this.$vs.loading.close();
      } catch (err) {
        this.$vs.loading.close();
        console.log(err);
      }
    },

    async getDebitNoteSOA(search) {
      this.$vs.loading();
      try {
        const response = await this.$http.get(
          "api/v1/debit-note/soa-cn-filter",
          {
            params: {
              search: search,
              territory_ids:
                this.$store.getters["operatingUnit/getSelectedTerritoryId"],
            },
          }
        );
        this.soaOption = response.data;
        this.$vs.loading.close();
      } catch (err) {
        this.$vs.loading.close();
        console.log(err);
      }
    },
  },
};
</script>
